import * as Yup from 'yup';
export const validationSchema = Yup.object().shape({
    slug: Yup.string()
        .required()
        .matches(/^[^-]/, 'Slug cannot start with a dash character.')
        .matches(/[^-]$/, 'Slug cannot end with a dash character.')
        .matches(/^[a-z0-9](-?[a-z0-9])*$/, 'URLs can only include letters, numbers, and "-" characters.'),
});
